import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { WhatsAppCtaBanner } from "../components/WhatsAppCtaBanner";
import { SectionEyebrow } from "../components/SectionEyebrow";

const FaqItem = ({ q, a, i, open, onToggle }) => (
  <div data-testid={`faq-item-${i}`} className="border-b border-[#E4E2DA]">
    <button
      type="button"
      onClick={onToggle}
      data-testid={`faq-toggle-${i}`}
      className="w-full flex items-start justify-between gap-6 py-6 text-left group"
    >
      <span className="font-serif text-xl lg:text-2xl font-light text-[#3E5239] group-hover:text-[#A7CA99] transition-colors">
        {q}
      </span>
      <span className={`text-[#A7CA99] text-2xl shrink-0 mt-1 transition-transform duration-300 ${open ? "rotate-45" : ""}`}>
        +
      </span>
    </button>
    <div className={`grid transition-all duration-300 ease-out ${open ? "grid-rows-[1fr] opacity-100 pb-6" : "grid-rows-[0fr] opacity-0"}`}>
      <div className="overflow-hidden">
        <p className="text-[#6B7A66] font-light leading-relaxed max-w-3xl">{a}</p>
      </div>
    </div>
  </div>
);

const FaqPage = () => {
  const { t } = useTranslation();
  const items = t("faq.items", { returnObjects: true });
  const [open, setOpen] = useState(0);
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="bg-[#F6F5F2]">
      <section className="pt-36 lg:pt-44 pb-16 bg-[#F6F5F2]">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <SectionEyebrow num="01">{t("faq.eyebrow")}</SectionEyebrow>
          <h1 className="font-serif text-5xl lg:text-7xl font-light tracking-tight leading-[0.95] text-[#3E5239]">
            {t("faq.title_l1")}
            <br />
            <span className="italic text-[#A7CA99]">{t("faq.title_l2")}</span>
          </h1>
        </div>
      </section>

      <section className="pb-16 lg:pb-24 bg-[#F6F5F2]">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          {items.map((it, i) => (
            <FaqItem key={it.q} q={it.q} a={it.a} i={i} open={open === i} onToggle={() => setOpen(open === i ? -1 : i)} />
          ))}
        </div>
      </section>

      <WhatsAppCtaBanner source="faq_page_bottom" />
    </div>
  );
};

export default FaqPage;
